import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import flatten from 'lodash/flatten';
import MarkdownHelper from '../../../helpers/MarkdownHelper';

var buildPlugin = function buildPlugin(plugin) {
  return plugin instanceof Function ? plugin() : plugin;
};

var sortPlugin = function sortPlugin(a, b) {
  if (a.index >= 0 && b.index >= 0) {
    return a.index < b.index ? -1 : 1;
  } else if (a.index >= 0) {
    return -1;
  } else if (b.index >= 0) {
    return 1;
  }

  return 0;
};

export default function getToolbarButtons(editor) {
  var plugins = flatten(editor.controller.middleware.toolbarButton.map(buildPlugin));
  var shortcuts = editor.controller.middleware.keyboardShortcut.reduce(function (memo, hotkey) {
    return _objectSpread({}, memo, {}, hotkey);
  }, {});
  return plugins.filter(function (plugin) {
    return !plugin.canApply || plugin.canApply(editor);
  }).map(function (plugin) {
    if (shortcuts[plugin.id]) {
      plugin.shortcut = shortcuts[plugin.id];
    }

    if (MarkdownHelper[plugin.id]) {
      plugin.markdown = MarkdownHelper[plugin.id];
    }

    return plugin;
  }).sort(sortPlugin);
}